import React, { Component } from 'react';
import { Table, Grid, Button, Icon, Popup } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import SearchTableData from '../util/SearchTableData';
import ReactExport from 'react-data-export';
import { getProgramName } from './ExternalStudentForms/ExternalStudentInputForm';
import PaginationFront from '../util/PaginationFront';
import { sanitizeExcelDataSet } from '../util/sanitizeExcel';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

class ExternalStudentsTable extends Component {
    render() {
        const {
            students,
            filteredStudents,
            excelData,
            activePage,
            postsPerPage,
            handlePaginationChange,

            getResults,
            handleSearchTextChange,

            deletingRowId,
            saving,

            handleDeleteClick,
            handleConfirmClick,
            handleCancelClick,

            isAdmin,
            isInternationalCooperationService,
            isStudentService,

            nonGradedWarnings,
        } = this.props;
        const indexOfLastPost = activePage * postsPerPage;
        const indexOfFirstPost = indexOfLastPost - postsPerPage;
        const currentStudents = filteredStudents.slice(indexOfFirstPost, indexOfLastPost);
        const showPagination = filteredStudents.length > postsPerPage;

        return (
            <React.Fragment>
            <Table celled selectable>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell colSpan={10}>
                            <Grid stackable verticalAlign="middle">
                                <Grid.Column width={14}>
                                    <SearchTableData
                                        profMozilla
                                        data={students}
                                        getResults={getResults}
                                        filterItem={['firstName', 'lastName']}
                                        onSearchTextChange={handleSearchTextChange}
                                    />
                                </Grid.Column>
                                <Grid.Column width={2} textAlign="right">
                                    <ExcelFile filename="Dolazne mobilnosti" element={<Popup
                                        trigger={<Button animated="vertical" color="green" basic
                                                         floated="right" fluid
                                                         style={{ textAlign: 'center' }}>
                                            <Button.Content hidden> <Icon
                                                name="download"/></Button.Content>
                                            <Button.Content visible>
                                                Excel
                                            </Button.Content>
                                        </Button>}
                                        content={<FormattedMessage id="externalStudent.downloadExcel"/>}
                                        hideOnScroll
                                        position="top center"
                                    />}>
                                        <ExcelSheet dataSet={sanitizeExcelDataSet(excelData)}
                                                    name="Studenti"/>
                                    </ExcelFile>

                                </Grid.Column>
                            </Grid>
                        </Table.HeaderCell>
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell colSpan={2}>{<FormattedMessage
                            id="externalStudent.fullName"/>}
                            <div style={{
                                fontSize: '0.85em',
                                color: '#999'
                            }}>{<FormattedMessage id="externalStudent.email"/>}</div>
                        </Table.HeaderCell>
                        <Table.HeaderCell colSpan={2}>{<FormattedMessage
                            id="externalStudent.programName"/>}
                            <div style={{
                                fontSize: '0.85em',
                                color: '#999'
                            }}>{<FormattedMessage id="externalStudent.mobilityProgram"/>}</div>
                        </Table.HeaderCell>
                        <Table.HeaderCell colSpan={2}>{<FormattedMessage
                            id="externalStudent.mobilityType"/>}
                            <div style={{
                                fontSize: '0.85em',
                                color: '#999'
                            }}>{<FormattedMessage id="externalStudent.mobilityFormat"/>}</div>
                        </Table.HeaderCell>
                        <Table.HeaderCell colSpan={2}>{<FormattedMessage
                            id="externalStudent.university"/>}
                            <div style={{
                                fontSize: '0.85em',
                                color: '#999'
                            }}>{<FormattedMessage id="externalStudent.sendingInstitutionCountry"/>}</div>
                        </Table.HeaderCell>
                        <Table.HeaderCell colSpan={1}>{<FormattedMessage
                            id="externalStudent.contactPerson"/>}
                            <div style={{
                                fontSize: '0.85em',
                                color: '#999'
                            }}>{<FormattedMessage id="externalStudent.email"/>} / {<FormattedMessage
                                id="externalStudent.phone"/>}</div>
                        </Table.HeaderCell>
                        <Table.HeaderCell width={1}/>
                    </Table.Row>
                </Table.Header>
                {filteredStudents.length > 0 ? (
                    <Table.Body>
                        {currentStudents.map((student, index) => (
                            <Table.Row key={index}>
                                <Popup
                                    content={
                                        student.mobilityType && student.mobilityType._key === 'non_cycle' ?
                                            new Date(student.dateTo) < new Date() ? (
                                                <FormattedMessage
                                                    id="externalStudent.exchangeEnded"
                                                    values={{
                                                        date: moment(student.dateTo)
                                                            .format('D. M. YYYY.')
                                                    }}
                                                />
                                            ) : (
                                                <FormattedMessage
                                                    id="externalStudent.exchangeEndsOn"
                                                    values={{
                                                        date: moment(student.dateTo)
                                                            .format('D. M. YYYY.')
                                                    }}
                                                />
                                            ) : student.semester && (student.semester.number === 2 || student.semester.number === 3)
                                                ?
                                                <FormattedMessage id="externalStudent.exchangeEndsOnSummer"
                                                                  values={{ academicYear: student.academicYear.name }}/>
                                                :
                                                <FormattedMessage id="externalStudent.exchangeEndsOnWinter"
                                                                  values={{ academicYear: student.academicYear.name }}/>
                                    }
                                    hideOnScroll
                                    position="left center"
                                    disabled={student.dropoutDate || student.graduationDate || student.lockedAt}
                                    trigger={
                                        <Table.Cell verticalAlign="middle" colSpan={2}>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}>
                                                <div style={{ flex: 1 }}>
                                                    <div>{indexOfFirstPost + index + 1}. {student.firstName} {student.lastName}
                                                        {
                                                            (nonGradedWarnings && nonGradedWarnings.has(student.id)) &&
                                                            <Popup
                                                                content={
                                                                    <div>
                                                                        <FormattedMessage
                                                                            id={'externalStudent.nonGradedWarning'}/>
                                                                        {nonGradedWarnings.get(student.id)
                                                                            .map((courseName, idx) => (
                                                                                <b key={idx}>
                                                                                    <br/>
                                                                                    {courseName}
                                                                                </b>
                                                                            ))
                                                                        }
                                                                    </div>
                                                                }
                                                                position="top center"
                                                                trigger={<Icon name="exclamation circle" color="yellow"
                                                                               style={{ marginLeft: '5px' }}/>}
                                                            />
                                                        }
                                                    </div>
                                                    <div style={{
                                                        fontSize: '0.85em',
                                                        color: '#999'
                                                    }}>
                                                        {student.email}
                                                    </div>
                                                </div>
                                                <span style={{ float: 'right', display: 'inline-flex', alignItems: 'center', gap: '6px', marginLeft: '8px' }}>
                                                    {student.lockedAt && <Icon name="lock" color="blue"/>}
                                                    {!student.lockedAt && student.dropoutDate &&
                                                        <Icon name="sign-out" color="red"/>}
                                                    {!student.lockedAt && student.graduationDate &&
                                                        <Icon name="graduation cap" color="green"/>}
                                                </span>
                                            </div>
                                        </Table.Cell>
                                    }/>

                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    <div>{getProgramName(student) || '-'}</div>
                                    <div style={{
                                        fontSize: '0.85em',
                                        color: '#999'
                                    }}>
                                        {student.mobilityProgram ? student.mobilityProgram.name : '-'}
                                    </div>
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    <div>{student.mobilityType ? student.mobilityType.name : '-'}</div>
                                    <div style={{
                                        fontSize: '0.85em',
                                        color: '#999'
                                    }}>
                                        {student.mobilityFormat ? student.mobilityFormat.name : '-'}
                                    </div>
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    <div>{student.sendingInstitutionName} - {student.sendingInstitutionFacultyName}</div>
                                    <div style={{
                                        fontSize: '0.85em',
                                        color: '#999'
                                    }}>
                                        {student.sendingInstitutionCountry && student.sendingInstitutionCountry.name}
                                    </div>
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={1}>
                                    <div>{student.sendingContactPersonFirstName} {student.sendingContactPersonLastName}</div>
                                    <div style={{
                                        fontSize: '0.85em',
                                        color: '#999'
                                    }}>
                                        {student.sendingContactPersonEmail || '-'} / {student.sendingContactPersonPhone || '-'}
                                    </div>
                                </Table.Cell>
                                {deletingRowId === student.id
                                    ?
                                    <Table.Cell textAlign="center" verticalAlign="middle" colSpan={1}>
                                        <Popup
                                            content={<FormattedMessage id="externalStudent.delete"/>}
                                            position="top center"
                                            trigger={<Button
                                                circular
                                                icon
                                                size="tiny"
                                                color="blue"
                                                onClick={handleConfirmClick}
                                                disabled={saving}
                                                loading={saving}
                                            >
                                                <Icon name="check"/>
                                            </Button>}/>
                                        <Popup
                                            content={<FormattedMessage id="externalStudent.cancel"/>}
                                            position="top center"
                                            trigger={<Button
                                                basic
                                                circular
                                                icon
                                                size="tiny"
                                                color="blue"
                                                onClick={handleCancelClick}
                                                disabled={saving}
                                            >
                                                <Icon name="close"/>
                                            </Button>}/>
                                    </Table.Cell>
                                    :
                                    <Table.Cell textAlign="center" verticalAlign="middle" colSpan={1}>
                                        <Popup
                                            content={<FormattedMessage
                                                id="externalStudent.studentProfile"/>}
                                            position="top center"
                                            trigger={
                                                <Button
                                                    as={Link}
                                                    to={{
                                                        pathname: '/dolazne-mobilnosti/student',
                                                        state: { student }
                                                    }}
                                                    onClick={() => {
                                                        localStorage.setItem('externalStudentId', student.id);
                                                    }}
                                                    size="small"
                                                    basic
                                                    circular
                                                    color={'blue'}
                                                    icon="user"
                                                    disabled={deletingRowId}
                                                />}
                                        />
                                        {(isAdmin || isInternationalCooperationService || isStudentService)
                                            && <Popup
                                                content={<FormattedMessage
                                                    id="externalStudent.delete"/>}
                                                position="top center"
                                                trigger={<Button
                                                    basic
                                                    circular
                                                    icon
                                                    size="tiny"
                                                    color="red"
                                                    disabled={(deletingRowId && deletingRowId !== student.id) || student.lockedAt}
                                                    onClick={() => handleDeleteClick(student.id)}
                                                ><Icon name="trash alternate"/></Button>}
                                            />}
                                    </Table.Cell>
                                }
                            </Table.Row>
                        ))}
                    </Table.Body>) : (
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell colSpan="10" textAlign="left">
                                <FormattedMessage id="common.noDataToDisplay"/>
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                )
                }
            </Table>
                {showPagination && (
                    <PaginationFront
                        postsPerPage={postsPerPage}
                        totalPosts={filteredStudents.length}
                        paginate={handlePaginationChange}
                        activePage={activePage}
                    />
                )}
            </React.Fragment>
        );
    }
}

export default ExternalStudentsTable;



// WEBPACK FOOTER //
// ./src/views/ExternalStudents/ExternalStudentTable.js